var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/brand/brand-breadcrumb.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
env.getTemplate("macros/urls.j2", false, "category/templates/brand/brand-breadcrumb.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("brandsUrl")) {
var t_4 = t_1.brandsUrl;
} else {
cb(new Error("cannot import 'brandsUrl'")); return;
}
context.setVariable("brandsUrl", t_4);
output += "\n\n<div class=\"o-row o-row--space\">\n\n    <div class=\"o-column o-extra-small--12\" itemscope itemtype=\"http://schema.org/CollectionPage\">\n\n        <nav class=\"c-breadcrumb\" role=\"navigation\" aria-label=\"breadcrumb navigation\" data-qa-breadcrumb-nav=\"\">\n\n            <ol class=\"c-breadcrumb__ol u-clearfix\">";
if(runtime.contextOrFrameLookup(context, frame, "category")) {
output += "<li class=\"c-breadcrumb__li\" data-qa-breadcrumb=\"\">\n                    <a href=\"";
output += runtime.suppressValue((lineno = 13, colno = 39, runtime.callWrap(t_4, "brandsUrl", context, ["",runtime.contextOrFrameLookup(context, frame, "None"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\" data-qa-prev-breadcrumb=\"\" class=\"c-breadcrumb__a\">\n                        <span>";
output += runtime.suppressValue((lineno = 14, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_brands-header"])), env.opts.autoescape);
output += "</span>\n                    </a>\n                </li>\n                <li class=\"c-breadcrumb__li c-breadcrumb__li--last\" data-qa-breadcrumb-last=\"\">\n                    <span data-qa-current-breadcrumb=\"\" aria-label=\"current page\" class=\"c-breadcrumb__span\">\n                        ";
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"brandNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug"));
frame.set("navItem", t_5, true);
if(frame.topLevel) {
context.setVariable("navItem", t_5);
}
if(frame.topLevel) {
context.addExport("navItem", t_5);
}
output += "\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "navItem")) {
output += "\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"displayName"), env.opts.autoescape);
output += "\n                        ";
;
}
output += "\n                    </span>\n                </li>";
;
}
else {
output += "<li class=\"c-breadcrumb__li c-breadcrumb__li--last\" data-qa-breadcrumb-last=\"\">\n                    <span data-qa-current-breadcrumb=\"\" aria-label=\"current page\" class=\"c-breadcrumb__span\">\n                        ";
output += runtime.suppressValue((lineno = 28, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_brands-header"])), env.opts.autoescape);
output += "\n                    </span>\n                </li>";
;
}
output += "</ol>\n\n        </nav>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/brand/brand-breadcrumb.j2"] , dependencies)